import { render, staticRenderFns } from "./RequestgroupDetail.vue?vue&type=template&id=ae850820"
import script from "./RequestgroupDetail.vue?vue&type=script&lang=js"
export * from "./RequestgroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports